// @unocss-include
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';
import { setUrlByFWorkItemId, setUrlByProjectCode } from '@/utils/routerBeforeEnter';
import storage from '@/utils/storage';
import _ from 'lodash';
import Layout from '../components/layout/index.vue';

const route: SiteRouteItem = {
  path: '/issue',
  name: PermissionPageKey.Issue,
  component: Layout,
  redirect: '/issue/list', // 默认首页子路由'
  meta: {
    title: 'site_route_item.issue',
    icon: 'tabler:bug',
    iconCls: 'bg-red-300',
  },
  children: [
    {
      path: 'dashboard',
      name: PermissionPageKey.IssueDashboard,
      component: () => import('../pages/issue-dashboard/index.vue'),
      meta: {
        title: 'site_route_item.issue.dashboard',
        icon: 'mingcute:dashboard-line',
      },
    },
    {
      path: 'list',
      name: PermissionPageKey.IssueList,
      // meta: { keepAlive: true },
      component: () => import('../pages/issue-list-view/index.vue'),
      meta: {
        title: 'site_route_item.issue.list',
        icon: 'mdi:git-issue',
        keepAlive: true,
      },
      // 飞书插件传参通过路由导航守卫做拦截和重新设值
      beforeEnter: (to, from, next) => {
        // 设置缓存，防止没有保存的字段丢失
        setSearchCache(Object.keys(to.query));
        setUrlByProjectCode(to, next, 'project');
      },
    },
    {
      path: 'detail/:issueKey',
      name: PermissionPageKey.IssueDetail,
      component: () => import('../pages/issue-detail/index.vue'),
      meta: {
        title: 'site_route_item.issue.detail',
        hideInMenu: true,
      },
      // 飞书插件传参通过路由导航守卫做拦截和重新设值
      beforeEnter: (to, from, next) => {
        // 设置缓存，防止没有保存的字段丢失
        setUrlByFWorkItemId(to, next);
      },
    },
    {
      path: 'setting',
      name: PermissionPageKey.IssueSetting,
      redirect: { name: PermissionPageKey.IssueSettingProjectConfig },
      meta: {
        title: 'site_route_item.issue.setting',
        icon: 'lets-icons:setting-fill',
        roles: ['admin'],
      },
      children: [
        {
          path: 'field-config',
          name: PermissionPageKey.IssueSettingFieldConfig,
          component: () => import('../pages/issue-setting/tab-pages/field-config/index.vue'),
          meta: {
            title: 'site_route_item.issue.setting.field_config',
            roles: ['admin'],
          },
        },
        {
          path: 'template-config',
          name: PermissionPageKey.IssueSettingTemplateConfig,
          component: () => import('../pages/issue-setting/tab-pages/template-config/index.vue'),
          meta: {
            title: 'site_route_item.issue.setting.template_config',
            roles: ['admin'],
          },
        },
        {
          path: 'template-scheme-config',
          name: PermissionPageKey.IssueSettingSchemeConfig,
          component: () => import('../pages/issue-setting/tab-pages/scheme-config/index.vue'),
          meta: {
            title: 'site_route_item.issue.setting.scheme_config',
            roles: ['admin'],
          },
        },
        {
          path: 'project-config',
          name: PermissionPageKey.IssueSettingProjectConfig,
          component: () => import('../pages/issue-setting/tab-pages/project-config/index.vue'),
          meta: {
            title: 'site_route_item.issue.setting.project_config',
            roles: ['admin'],
          },
        },
        {
          path: 'dept-responsible-mapping',
          name: PermissionPageKey.IssueSettingDeptResponsibleMapping,
          component: () => import('../pages/issue-setting/tab-pages/dept-responsible-mapping/index.vue'),
          meta: {
            title: 'site_route_item.issue.setting.dept_responsible_mapping',
            roles: ['admin'],
          },
        },
        {
          path: 'dept-rollup-rule',
          name: PermissionPageKey.IssueSettingDeptRollupRule,
          component: () => import('../pages/issue-setting/tab-pages/dept-rollup-rule/index.vue'),
          meta: {
            title: 'site_route_item.issue.setting.dept_rollup_rule',
            roles: ['admin'],
          },
        },
      ],
    },
    {
      path: 'feishu-work-item-setting',
      name: PermissionPageKey.IssueFeishuWorkItemSetting,
      component: () => import('../pages/issue-feishu-work-item-setting/index.vue'),
      meta: {
        title: 'site_route_item.issue.feishu_work_item_setting',
        icon: 'lets-icons:setting-fill',
        hideInMenu: true,
      },
    },
  ],
};

/**
 * @description 设置缓存，防止没有保存的字段丢失
 */
const setSearchCache = (query: string[]) => {
  const cache = storage.get('issueSearchDynamicFieldKeys');
  if (cache) {
    const newCache = _.union(JSON.parse(cache), query);
    storage.set('issueSearchDynamicFieldKeys', JSON.stringify(newCache));
  } else {
    storage.set('issueSearchDynamicFieldKeys', JSON.stringify(query));
  }
};

export default route;
